import { Suspense, useState } from 'react';
import { hydrate, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { DefaultLoadingFallback } from '@cx-modules/react-utils';

import type { FaqIndexProps } from '../contract';

import { Faq } from './Faq';

const createQueryClient = (nocache?: boolean) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: nocache ? 0 : undefined,
        refetchOnMount: nocache ? true : false,
        staleTime: nocache ? 0 : Infinity,
      },
    },
  });

export default function FaqWithQuery({ dehydratedState, nocache, ...props }: FaqIndexProps) {
  const [queryClient] = useState(() => {
    const client = createQueryClient(nocache);
    hydrate(client, dehydratedState);
    return client;
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<DefaultLoadingFallback />}>
        <Faq {...props} />
      </Suspense>
    </QueryClientProvider>
  );
}

// The props type is part of the public API — every consumer wraps this component and types its
// own props with it. Re-exported explicitly: the dist `.d.ts` dts-bundle-generator used to emit
// hoisted it automatically, and since NGF-6661 this file IS the package's type surface.
export type { FaqIndexProps } from '../contract';

export { loadDataForServer } from './loadData';
